
;
                (function(){
                    const Func = (function() {
                        if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-4ipfs0ksicq';
                    document.querySelectorAll('.ecom-4ipfs0ksicq').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-u416qnjd54o';
                    document.querySelectorAll('.ecom-u416qnjd54o').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(!this.$el)return!1;const e=this.$el,t=function(i){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let a=parseInt(i.settings.animation_loop_time)*1e3||6e3,o=1e3;setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},a)};this.settings.animation&&t(this)
                    
                    });
                    const settings = {};
                    const ID = 'ecom-k5q4aebcya9';
                    document.querySelectorAll('.ecom-k5q4aebcya9').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-8t8v2kgdvpm';
                    document.querySelectorAll('.ecom-8t8v2kgdvpm').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-0csbzzuy0d0u';
                    document.querySelectorAll('.ecom-0csbzzuy0d0u').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}
                    
                    });
                    const settings = {"link":"lightbox","lightbox":"no"};
                    const ID = 'ecom-q7m1ln1z5s';
                    document.querySelectorAll('.ecom-q7m1ln1z5s').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            